import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { ICONS } from './icon-map';
import './Card/card.css';
import './ds.css';

/**
 * Module card: icon tile, title, one-line description, optional meta.
 * Renders as a link when `path` is set, otherwise as a button.
 */
const ModuleCard = ({
    title,
    desc,
    iconGlyph,
    onClick,
    path,
    meta,
    style = {},
    className = '',
}) => {
    const content = (
        <>
            <span className="module-card__icon"><Icon glyph={iconGlyph} size="md" /></span>
            <span className="module-card__text">
                <span className="module-card__title">{title}</span>
                {desc && <span className="module-card__desc">{desc}</span>}
            </span>
            {meta ? <span className="module-card__meta">{meta}</span> : null}
            <span className="module-card__chev"><Icon glyph={ICONS.chevronRight} size="sm" /></span>
        </>
    );

    const classes = `card card--interactive module-card ${className}`;

    if (path) {
        return (
            <Link to={path} className={classes} style={style}>
                {content}
            </Link>
        );
    }

    return (
        <button type="button" onClick={onClick} className={classes} style={style}>
            {content}
        </button>
    );
};

export default ModuleCard;
